<template>
    <div class="xc-page reset xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/user'">系统设置</router-link>
                <a>知识图谱</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form
                            class="xc-form"
                            name="search"
                            @submit.prevent="mix_search"
                        >
                            <div class="xc-form-inline">
                                <xc-form-item label="名称:">
                                    <input
                                        type="text"
                                        name="knowledgeName"
                                        v-model="mix_query.knowledgeName"
                                        class="xc-input"
                                        placeholder="请输入名称"
                                    >
                                </xc-form-item>
                                <xc-form-item label="语音指令:">
                                    <input
                                        type="text"
                                        name="voiceCommand"
                                        v-model="mix_query.voiceCommand"
                                        class="xc-input"
                                        placeholder="请输入语音指令"
                                    >
                                </xc-form-item>
                                <xc-form-item label="知识图谱类型:">
                                    <select
                                        class="xc-select"
                                        name="knowledgeType"
                                        v-model="mix_query.knowledgeType"
                                    >
                                        <option value selected>全部</option>
                                        <option value="WD">问答</option>
                                        <option value="AJ">艾灸</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item label="状态:">
                                    <select
                                        class="xc-select"
                                        name="stopStatus"
                                        v-model="mix_query.stopStatus"
                                    >
                                        <option value selected>全部</option>
                                        <option value="0">启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button
                                        type="submit"
                                        class="xc-btn xc-btn-primary"
                                    >查询
                                    </button>
                                    <button
                                        class="xc-btn xc-btn-default"
                                        type="button"
                                        @click="add"
                                    >添加
                                    </button>
                                </div>
                            </div>
                        </form>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th>名称</th>
                                    <th>语音指令</th>
                                    <th>知识图谱类型</th>
                                    <th>指令播放类型</th>
                                    <th>播放内容</th>
                                    <th>状态</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>{{item.knowledgeName}}</td>
                                        <td>{{item.voiceCommand}}</td>
                                        <td>{{item.knowledgeType | getknowledgeType}}</td>
                                        <td>{{item.playbackType | getplaybackType}}</td>
                                        <td>
                                            <div class="musicPreview" v-if="item.speech" @click="viewMaterial(item.knowledgeName,item.speech)">
                                                预览音频文件
                                            </div>
                                        </td>
                                        <td>{{item.stopStatus | getStatus}}</td>
                                        <td>
                                            <xc-btn-select
                                                title="管理"
                                            >
                                                <template v-if="groups(item).length">
                                                    <xc-btn-select-item
                                                        v-for="(obj,key) in groups(item)"
                                                        :key="key"
                                                        :title="obj.name"
                                                        @click.native="mix_action(obj,item,$event)"
                                                    ></xc-btn-select-item>
                                                </template>
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination
                @change="pageChange"
                :page="mix_page"
                :total="mix_total"
                :size="mix_pageSize"
            />
        </div>
        <div class="xc-card">
            <!--添加/编辑-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName =='add' || modalName =='edit'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName =='add'?'添加':'编辑' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName=null"
                            ></div>
                        </div>
                        <div class="xc-modal-body" style="max-height: 550px;">
                            <form
                                class="xc-form"
                                name="add"
                                data-vv-scope="add"
                            >
                                <xc-form-item
                                    label="项目名称:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="knowledgeName"
                                        class="xc-input"
                                        v-model="fomData.knowledgeName"
                                        v-validate="'required'"
                                        data-vv-as="项目名称"
                                        placeholder="请输入项目名称"
                                        :class="{'xc-input-error':errors.first('knowledgeName','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("knowledgeName","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="语音指令:"
                                    required
                                >
                                    <input
                                        type="text"
                                        name="voiceCommand"
                                        class="xc-input"
                                        v-validate="'required'"
                                        v-model="fomData.voiceCommand"
                                        data-vv-as="语音指令"
                                        placeholder="请输入语音指令"
                                        :class="{'xc-input-error':errors.first('voiceCommand','add')}"
                                    >
                                    <div class="xc-form-item-error-tips">
                                        {{errors.first("voiceCommand","add")}}
                                    </div>
                                </xc-form-item>
                                <xc-form-item
                                    label="知识图谱类型"
                                    required
                                    :error="errors.first('knowledgeType','add')"
                                >
                                    <select
                                        name="knowledgeType"
                                        class="xc-select"
                                        v-model="fomData.knowledgeType"
                                        v-validate="'required'"
                                        data-vv-as="知识图谱类型"
                                    >
                                        <option value selected>请选择</option>
                                        <option
                                            value="WD"
                                            selected
                                        >问答</option>
                                        <option value="AJ">艾灸</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="状态"
                                    required
                                    :error="errors.first('stopStatus','add')"
                                >
                                    <select
                                        name="stopStatus"
                                        class="xc-select"
                                        v-model="fomData.stopStatus"
                                        v-validate="'required'"
                                        data-vv-as="状态"
                                    >
                                        <option
                                            value="0"
                                            selected
                                        >启用</option>
                                        <option value="1">禁用</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item
                                    label="指令播放类型："
                                    required
                                    :error="errors.first('playbackType','add')"
                                >
                                    <select
                                        name="playbackType"
                                        class="xc-select"
                                        v-model="fomData.playbackType"
                                        v-validate="'required'"
                                        data-vv-as="指令播放类型"
                                        @change="playbackTypeChange"
                                    >
                                        <option
                                            value="TEXT"
                                            selected
                                        >文字转语音</option>
                                        <option value="MP3">语音文件</option>
                                    </select>
                                </xc-form-item>
                                <xc-form-item 
                                    v-if="fomData.playbackType === 'TEXT'"
                                    label="播放内容:"
                                    required
                                >
                                    <textarea
                                        name="playbackContent"
                                        class="xc-textarea"
                                        v-model.trim="fomData.playbackContent"
                                        placeholder="请输入播放内容"
                                    ></textarea>
                                    <button
                                        type="button"
                                        class="xc-btn xc-btn-primary"
                                        @click="textToAudio()"
                                    >
                                    文字转语音
                                    </button>
                                </xc-form-item>
                                <xc-form-item 
                                    v-if="fomData.playbackType === 'TEXT' && fomData.speech"
                                    label="文字转语音文件:"
                                >
                                    <audio controls ref="audio" class="aud">
                                        <source :src="fomData.speech" />
                                    </audio>  
                                </xc-form-item>

                                <xc-form-item
                                    v-if="fomData.playbackType === 'MP3'"
                                    label="文件"
                                    style="align-items: inherit"
                                    required
                                    class="position-upload"
                                >   
                                    <xc-upload1
                                        :fileList.sync="fomData.files"
                                        type="0"
                                        accept=".mp3"
                                        :url="uploadUrl"
                                        :multiple="true"
                                        :beforeUpload="beforeUpload"
                                        @update:fileList="updateFileList"
                                    />
                                    <input
                                        type="file"
                                        class="file-input"
                                        id="file-selector"
                                        size="small"
                                        accept=".mp3"
                                        @change="changeFile"
                                        @del="del"
                                    />
                                </xc-form-item>
                            </form>
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-default"
                                    @click="modalName=null"
                                >取消
                                </button>
                                <button
                                    type="button"
                                    class="xc-btn xc-btn-primary"
                                    @click="addSubmit"
                                >保存
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--启用/禁用-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='active' || modalName =='disabled'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">{{ modalName=='active'?'启用':'禁用' }}</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            {{ modalName=='active'?'确定启用该面板控制，启用后将恢复正常？':'确定禁用该面板控制，禁用后该面板不能使用？' }}
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="enableSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--删除-->
            <div
                class="xc-modal xc-modal-dialog"
                v-if="modalName=='delete'"
            >
                <div
                    class="xc-modal-mask"
                    @click="modalName=null"
                ></div>
                <div class="xc-modal-wrap xc-anim-scaleIn">
                    <div class="xc-modal-content">
                        <div class="xc-modal-header">
                            <div class="xc-modal-title">删除</div>
                            <div
                                class="xc-modal-close"
                                @click="modalName = null"
                            ></div>
                        </div>
                        <div class="xc-modal-body xc-flex-center">
                            确定删除该信息？
                        </div>
                        <div class="xc-modal-footer xc-flex-center">
                            <div class="xc-btn-group">
                                <button
                                    class="xc-btn xc-btn-default"
                                    @click="modalName = null"
                                >取消
                                </button>
                                <button
                                    class="xc-btn xc-btn-primary"
                                    @click="deleteSubmit"
                                >确定
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import "@/libs/font-awesome"
import "@/libs/vee-validate"
import "@/libs/vue-select"
import "@/utils/form-format"
import { uploadFile } from "@/utils/uploadfile";
import Knowledge from "@/api/systemKnowledge"
import myLayerImport from '@/libs/myLayer';
import loadScript from "../utils/load-script";

// ip格式化
import "@/utils/ip-format";
import xui from "@/xc-ui";

myLayerImport();

export default {
    name: 'systemKnowledge',
    mixins: [listMixin],
    data() {
        return {
            deviceGroupIds:"",
            adminPath: this.$config.adminPath,
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'id',

            list: [],
            stores: [], //门店列表
            roles: [],   //角色列表
            // 默认查询参数
            mix_query: {
                knowledgeName: "",
                voiceCommand: "",
                stopStatus: "",
                knowledgeType:""

            },
            group: [
                {
                    name: "编辑",
                    id: 0
                },
                {
                    name: "删除",
                    id: 1
                },
                {
                    name: "启用",
                    id: 2,
                },
                {
                    name: "禁用",
                    id: 3,
                }
            ],
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,  //当前表行
            fomData: {
                files:[]
            },  //表单数据
            uploadUrl: "",
        }
    },
    filters: {
        getStatus: function (value) {
            if (value == 0) {
                return "启用"
            }
            return "禁用";
        },
        getknowledgeType:function(value){
            if(value == 'WD'){
                return "问答";
            }else if(value =='AJ'){
                return "艾灸";
            }
        },
        getplaybackType:function(value){
            if(value == 'TEXT'){
                return "文字转语音";
            }else if(value =='MP3'){
                return "语音文件";
            }
        },
    },
    methods: {
        // 初始化数据
        initData() {
            var _this = this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            //请求列表数据
            Knowledge.getKnowledgeByPage({params:search}).then(function (ret) {
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            });
        },
        // 更新分页
        pageChange: function (page, pageSize) {
            this.mix_page = page;
            this.mix_pageSize = pageSize;
            this.initData();
        },
        // 打开添加弹窗
        add() {
            this.modalName = "add";
            this.fomData = {
                files:[],
                knowledgeType:'',
                playbackType: "TEXT",
                stopStatus: 0
            }
        },
        playbackTypeChange(){
            //强制刷新视图
            this.$forceUpdate()
        },
        // 操作单条数据
        action(...args) {
            const [action, item] = args;
            this.current = { ...item };
            this.fomData = { ...item }
            switch (action.name) {
                case "编辑":
                    this.modalName = "edit";
                    if(this.fomData.playbackType === 'MP3'){
                        setTimeout(()=>{
                            this.fomData.files.push({url:this.fomData.speech,name:'语音播放文件.mp3'})
                        },100)
                    }
                    break;
                case "启用":
                    this.modalName = "active";
                    break;
                case "禁用":
                    this.modalName = "disabled";
                    break;
                case "删除":
                    this.modalName = "delete";
                    break;
                default:
                    break;
            }
        },
        groups: function (item) {
            var arr = this.group.slice(0);
            if (item.stopStatus == 0) {
                //0表示启用,1表示禁用
                arr.splice(2, 1);
            } else {
                arr.splice(3, 1)
            }
            return arr;
        },
        textToAudio(){
            //文字转语音
            if(this.fomData.playbackContent){
                let loading = xui.loading({
                    text: "转换中..."
                });
                this.fomData.speech = "";
                Knowledge.textToMp3({text:this.fomData.playbackContent}).then((res)=>{
                    this.fomData.speech = res.data;
                    loading.close();
                    this.$forceUpdate()
                })
            } else {
                this.$message.waring("请先输入转换文本内容！");
            }
            
        },
        // 添加确定
        addSubmit: function () {
            var myForm = document.add;
            // 验证器命名空间
            const scope = 'add';
            this.$validator.validateAll(scope).then(validate => {
                if (validate) {
                    const data = this.$formFormat(myForm);
                    if(this.fomData.playbackType === 'MP3'){
                        data.playbackContent = this.fomData.files[0].url;
                        data.speech = this.fomData.files[0].url;
                    }
                    if(this.fomData.playbackType === 'TEXT' && this.fomData.speech == ''){
                        this.$message.waring("请先转换文本内容转为语音！");
                        return;
                    }

                    if(this.fomData.playbackType === 'TEXT'){
                       data.speech = this.fomData.speech;
                    }
                    if(this.modalName === "add"){
                        Knowledge.addKnowledge(data).then(() => {
                            this.$message.success("添加成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }else{
                         if (this.current.playbackContent != this.fomData.playbackContent && this.current.speech == this.fomData.speech) {
                            this.$message.waring("若要保存播放内容，请先转为语音文件！");
                            return;
                        }
                        
                        data.knowledgeId = this.current.knowledgeId;
                        Knowledge.updateKnowledge(data).then(() => {
                            this.$message.success("修改成功");
                            this.modalName = null;
                            this.initData();
                        })
                    }
                } else {
                    return false;
                }

            })
        },

        //启用、禁用
        enableSubmit: function () {
            var _this = this;
            var currentstatus = 0;
            if(this.modalName=='disabled'){
                currentstatus = 1;
            }
            var obj = {
                knowledgeId: this.current.knowledgeId,
                stopStatus: currentstatus
            };

            Knowledge.stopStatus(obj).then(function () {
                var statusText = '启用成功';
                if(_this.modalName === 'disabled'){
                    statusText = '禁用成功';
                }
                _this.$message.success(statusText);
                _this.modalName = null;
                _this.initData();
            }).catch(function (error) {
                console.log(error)
            })
            
        },
        // 删除确认
        deleteSubmit() {
            Knowledge.deleteKnowledge(this.current.knowledgeId).then(v => {
                this.$message.success(v.msg);
                this.modalName = null;
                this.initData()
            })
        },
        beforeUpload(file) {
            if (!this.sysConfig.upload_max_video_size) {
                this.$message.error("上传配置获取识别，请稍后重试");
                return false;
            }

            const maxSize = this.sysConfig.upload_max_video_size.value * 1024 * 1024;
            const passSuffix = this.sysConfig.pass_video_suffix.value.split(",");

            if (file.size > maxSize) {
                this.$message.error(
                "音乐大小不能超过" + this.sysConfig.upload_max_video_size.value + "MB"
                );
                return false;
            }

            const suffixAry = file.name.split(".");
            if (suffixAry.length == 0) {
                this.$message.error(
                "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
                );
                return false;
            }

            // 判断是否允许的格式
            const allowType = passSuffix.some((item) => {
                return suffixAry[suffixAry.length - 1] == item;
            });

            // 不允许的文件格式
            if (!allowType) {
                this.$message.error(
                "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
                );
                return false;
            }
        },
        changeFile(event) {
            let file = event.target.files[0];
            if (!file) return;
            this.loading = true;
            this.cosUploadFile(file);
        },
        // 通过腾讯云 cos-js-sdk-v5 上传
        cosUploadFile(file) {
            uploadFile(file, async (err, data) => {
                if (err) {
                    console.log(err);
                } else {
                    console.log(data, "data");
                    let fileData = JSON.parse(JSON.stringify(data));
                    var au = document.createElement("audio");
                    au.src = data.fid;
                    this.loading = false;
                    fileData.url = data.fid;
                    fileData.file = data.fid;
                    fileData.md5 = file.md5;
                    fileData.type = file.type;
                    fileData.name = file.name;
                    fileData.size = file.size;
                    fileData.status = "success";
                    this.fomData.files.push(fileData);
                    console.log(this.fomData.files, "this.data.files");
                }
            });
        },
        del() {
            document.getElementById("file-selector").value = "";
            this.fomData.files=[]
        },
        updateFileList(files) {
            //  console.log(files,"wwwwwwwwwwwwwww");
            // this.fomData.files=[]
        },
        //  预览音频文件
        viewMaterial(name,url) {
            var _this = this;
            myLayer.open({
                type: 2,
                title: false,
                shadeClose: true,
                closeBtn: 0, //不显示关闭按钮
                area: ["981px", "550px"],
                content:
                _this.adminPath +
                "/material/preview?name=" +
                name +
                "&type=audio" +
                "&url=" +
                url,
                success: function () {},
            });
        },

    },
    created() {
        loadScript("/libs/md5.js");
    }
}
</script>

<style  lang="scss">
@import "../xc-ui/scss/variable";
.reset {
    form[name="reset"] {
        .xc-form-item-label {
            width: 80px;
        }
    }
}
.position-upload {
  position: relative;
}
.file-input {
  position: absolute;
  top: 0;
  min-height: 40px;
  opacity: 0;
}
.musicPreview{
    color: #507dde;
    cursor: pointer;
}
</style>

